import { Resume } from '../../resume/resume';
import { convertResumeJsonToMarkdown } from './get-resume-content.prompt';

export function changeResumeNamePrompt(config: {
  oldName: {
    firstName: string;
    lastName: string;
  };
  newName: {
    firstName: string;
    lastName: string;
  };
  resume: Resume;
}) {
  const customerInfo = convertResumeJsonToMarkdown(config.resume.subData.content as any, true);

  return `
    Replace the name of the person to use new Name: ${config.newName.firstName} and Last Name: ${config.newName.lastName} in the resume.

    Inspect each line of the resume and update the name of old First Name ${config.oldName.firstName} and old Last Name ${config.oldName.lastName} to the new name.

    You should only output the results in cleaned structured markdown format.

    Here are the resume:
    <RESUME>
      ${customerInfo}
    </RESUME>
  `;
}

export function changeResumeNameFunctions(config: {
  oldName: {
    firstName: string;
    lastName: string;
  };
  newName: {
    firstName: string;
    lastName: string;
  };
  resume: Resume;
}) {
  return [
    {
      name: 'change_resume_name',
      description: `Replace the name of the person to use new Name: "${config.newName.firstName}" and Last Name: "${config.newName.lastName}" in the resume. Inspect each section of the resume and update the name of old First Name "${config.oldName.firstName}" and old Last Name "${config.oldName.lastName}" to the new name.`,
      parameters: {
        type: 'object',
        properties: {
          painPoints: {
            type: 'array',
            description: '3-5 specific pain points the customer may experience.',
            items: { type: 'string' },
            minItems: 3,
            maxItems: 5,
          },
          gender: {
            type: 'string',
            desciption: 'Pick a gender from male or female based on the customer profile.',
            enum: ['male', 'female'],
          },
          portraitImageUrl: {
            type: 'string',
            description: 'The portrait image url of the resume if any.',
          },
          firstName: {
            type: 'string',
            description: 'If available, the first name of the person mentioned in the resume.',
          },
          middleName: {
            type: 'string',
            description: 'If available, the middle name of the person mentioned in the resume.',
          },
          lastName: {
            type: 'string',
            description: 'If available, the last name of the person mentioned in the resume.',
          },
          personality: {
            type: 'string',
            desciption:
              'Based on the resume, provide your best guess of the person’s personality. The personality should be one of the following: professional, casual, rude, friendly, curious, disinterested, brief.',
            enum: ['professional', 'casual', 'rude', 'friendly', 'curious', 'disinterested', 'brief'],
          },
          personalInformation: { type: 'object', description: "Customer's personal information" },
          workExperience: { type: 'string', description: "Customer's work experience. Extract specific details, do not miss any information, do not change words, do not summarize, do not remove numbers." },
          mostRecentCompany: { type: 'string', description: "Customer's most recent company" },
          mostRecentPosition: { type: 'string', description: "Customer's most recent position" },
          projectExperience: { type: 'string', description: "Customer's project experience" },
          education: { type: 'string', description: "Customer's education" },
          skills: { type: 'array', description: "Customer's skills", items: { type: 'string' } },
          certifications: { type: 'array', description: "Customer's certifications", items: { type: 'string' } },
          awards: { type: 'array', description: "Customer's awards", items: { type: 'string' } },
          publications: { type: 'array', description: "Customer's publications", items: { type: 'string' } },
          languages: { type: 'array', description: 'Languages spoken by the customer', items: { type: 'string' } },
          interests: { type: 'array', description: "Customer's interests", items: { type: 'string' } },
          references: { type: 'array', description: "Customer's references", items: { type: 'string' } },
          otherDetails: { type: 'string', description: 'Other relevant details about the customer' },
        },
      },
    },
  ];
}
